// extracted by mini-css-extract-plugin
module.exports = {"CustomOverlay":"CustomWithSpinner_CustomOverlay__2UNVi","SpinnerContainer":"CustomWithSpinner_SpinnerContainer__3uFah"};